import { motion } from "framer-motion";

const IMGS = [
  { src: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Hawa_Mahal_%28The_Palace_of_Winds%29_in_Jaipur%2C_20191218_1201_9174.jpg/1280px-Hawa_Mahal_%28The_Palace_of_Winds%29_in_Jaipur%2C_20191218_1201_9174.jpg", alt: "Jaipur Hawa Mahal", big: false },
  { src: "https://images.pexels.com/photos/19160105/pexels-photo-19160105.jpeg?auto=compress&cs=tinysrgb&w=800", alt: "Jodhpur Blue City", big: true },
  { src: "https://images.pexels.com/photos/35130760/pexels-photo-35130760.jpeg?auto=compress&cs=tinysrgb&w=800", alt: "Jaisalmer Fort", big: false },
  { src: "https://images.pexels.com/photos/533928/pexels-photo-533928.jpeg?auto=compress&cs=tinysrgb&w=800", alt: "Mount Abu", big: false },
  { src: "https://images.pexels.com/photos/27960113/pexels-photo-27960113.jpeg?auto=compress&cs=tinysrgb&w=800", alt: "Udaipur Lake Palace", big: true },
  { src: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Sunset_over_Great_Thar_Desert_at_Osiyan_%284571264157%29.jpg/1280px-Sunset_over_Great_Thar_Desert_at_Osiyan_%284571264157%29.jpg", alt: "Osian Desert Safari", big: false },
  { src: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Astapadh_temple%2C_Nakoda.jpg/1280px-Astapadh_temple%2C_Nakoda.jpg", alt: "Nakoda Ji Tour", big: false },
];

export default function Gallery() {
  return (
    <section id="gallery" className="bg-brand-cream text-brand-ink py-24 md:py-32" data-testid="gallery-section">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] font-semibold text-brand-blue">Chapter VII · Gallery</div>
            <h2 className="mt-4 font-display font-black text-5xl md:text-6xl leading-[1.02]">
              Postcards from <span className="italic text-brand-orange font-medium">the road.</span>
            </h2>
          </div>
          <p className="max-w-md text-brand-ink/65">A quiet album of the palaces, dunes and lakes we drive through — every single week.</p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-3 md:gap-4">
          {IMGS.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
              className={`group relative overflow-hidden rounded-3xl bg-brand-ink ${img.big ? "row-span-2" : ""}`}
              data-testid={`gallery-item-${i}`}
            >
              <img src={img.src} alt={img.alt} loading="lazy" style={{ objectPosition: img.objectPos || "center" }} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-4 left-4 text-white text-xs font-medium tracking-[0.16em] uppercase opacity-0 group-hover:opacity-100 transition-opacity">
                {img.alt}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
